export default {
  modalTitle: 'Votre Espace client fait peau neuve!',
  modalText: 'Avec un visuel épuré et une navigation simplifiée et plus intuitive, votre Espace client a maintenant tout pour vous plaire :',
  modalLineText1: 'Page d\'accueil complètement revampée',
  modalLineText2: 'Sections Profil, Messagerie et Documents améliorées',
  modalLineText3: 'Ajout de nouvelles fonctionnalités de notifications et d\'actions requises',
  modalLineText4: 'Expérience uniformisée et optimisée pour tous vos appareils',
  exploreButton: 'C\'est parti!',
};
